import { useContext, useDebugValue } from 'react';
import { TabsContext } from './TabsContext.ts';

export function useActiveTab() {
    const ctx = useContext(TabsContext);
    if (!ctx) {
        throw new Error(
            'Consuming `TabsContext` outside the Provider. Make sure Consumer Component is wrapped inside the `Tabs`.',
        );
    }
    return ctx;
}

export function useActiveTabIdx() {
    const idx = useActiveTab()[0];
    useDebugValue(`activeTabIdx ${idx}`);
    return idx;
}
